import { Component } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  header1 = $localize`Contact`;

  info = [
    {
      text: $localize`No running costs are incurred for the use of the Test Platform. These are covered by the Federal Office for Information Security (BSI).`,
      color: '#4c9cb4'
    },
    {
      text: $localize`There are one-off hardware costs for the CLS interface required to use the platform.`,
      color: '#007194'
    },
    {
      text: $localize`If you are interested in accessing the Smart-Metering Test Platform for CLS, you can contact us via the following contact form. This will be followed by a check by the BSI. Upon approval, you will receive the access data and invoice from umlaut energy GmbH.`,
      color: '#014459'
    },
  ];

  goToContactForm(): void {
    window.open('https://smtpf.io/contact', '_blank');
  }
}
